import { SET_LEAD_SOURCE, SET_SNACK, SET_SNACK_INFO, SET_SALES_DATA, SET_USERS_DATA, SET_SALES_STAGE_LEAD, CLEAR_SALES_DATA, LOGOUT, SET_SALESL2M_DATA, CLEAR_L2M_DATA, SET_DESIGN_STAGE_LEAD, SET_MEETING_TRACKER,  SET_STAGE_REVIEW, PROJECT_NO, MONTHLY_CONVERSION_GOAL  } from "./types";
import HttpService from "../../services/httpService";

export const getSourceOfLeadData = () => async (dispatch) => {
  try {
    const response = await HttpService.getLeadMaster(); // Fetch lead data
    dispatch({ type: SET_LEAD_SOURCE, payload: response.data });
  } catch (error) {
    console.error(error);
    dispatch({ type: SET_SNACK, payload: true });
    dispatch({
      type: SET_SNACK_INFO,
      payload: { msg: error.response?.data || "Error fetching lead source", snackSeverity: "error" },
    });
  }
};

export const setLatestScan = (data) =>{
  return {
    type : PROJECT_NO,
    payload : data
  }
}

//Set getLeadToMeetingOrderData
export const leadToMeetingOrderData = (data) => {
  return {
    type: SET_SALESL2M_DATA,
    payload: data
  };
};

// Action creator for setting sales data
export const setSalesData = (data) => {
  return {
    type: SET_SALES_DATA,
    payload: data
  };
};

// Action creator for setting users data
export const setUsersDataInRedux = (data) => {
  return {
    type: SET_USERS_DATA,
    payload: data
  };
};

// ✅ New action creator for setting sales stage lead
export const setSalesStageLead = (data) => {
  return {
    type: SET_SALES_STAGE_LEAD,
    payload: data
  };
};

// ✅ New action creator for setting sales stage review lead
export const setStageReview = (data) => {
  return {
    type: SET_STAGE_REVIEW,
    payload: data
  };
};

// ✅ New action creator for setting design  stage summary
export const setOverAllDesignSummary = (data) => {
  return {
    type: SET_DESIGN_STAGE_LEAD,
    payload: data
  };
};

// ✅ New action creator for setting sales meeting info
export const setMeetingTrack = (data) => {
  return {
    type: SET_MEETING_TRACKER,
    payload: data
  };
};



export const clearSalesStageLead = () => {
  return {
      type: CLEAR_SALES_DATA
  };
};

export const clearL2Mdata = () => {
  return {
      type: CLEAR_L2M_DATA
  };
};


// ✅ New action creator for logout
export const logoutUser = () => {
  return {
    type: LOGOUT
  };
};

// ✅ Monthly Conversion Goal
export const setMonthlyConversionGoal = (data) => {
  return {
    type: MONTHLY_CONVERSION_GOAL,
    payload: data
  };
};

